import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule]
})
export class LoginComponent implements OnInit {
  singInForm = new FormGroup({
    userName: new FormControl('', {
      validators: [Validators.required, Validators.email],
    }),
    userPassword: new FormControl('', {
      validators: [Validators.required, Validators.minLength(6)],
    }),
  });

  errorLoggin = false;

  production = environment.production;

  private readonly authService = inject(AuthService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.singInForm.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => (this.errorLoggin = false));
  }

  signInWithEmailAndPassword() {
    this.authService
      .signInWithEmailAndPassword(
        this.singInForm.value.userName || '',
        this.singInForm.value.userPassword || '',
        this.activatedRoute.snapshot.params['redirectTo']
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: () => {
          this.errorLoggin = true;
        },
        complete: () => (this.errorLoggin = false),
      });
  }

  signInWithGoogle() {
    this.authService
      .signInWithGoogle(this.activatedRoute.snapshot.params['redirectTo'])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: () => {
          this.errorLoggin = true;
        },
        complete: () => (this.errorLoggin = false),
      });
  }

  signInWithMicrosoft() {
    this.authService
      .signInWithMicrosoft(this.activatedRoute.snapshot.params['redirectTo'])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: () => {
          this.errorLoggin = true;
        },
        complete: () => (this.errorLoggin = false),
      });
  }
}
